import ModalCenter from "./ModalCenter";
export default ModalCenter;
